import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=6493a257"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./NotFound.vue?vue&type=custom&index=0&blockType=meta&name=viewport&content=width%3Ddevice-width%2C%20initial-scale%3D1"
if (typeof block0 === 'function') block0(component)

export default component.exports